<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology Handles</h2>
        <h3>Wire Contoured Handles</h3>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-handles-contour-wire1@1x.jpg"
              src2="contrology-handles-contour-wire1@2x.jpg"
              alt="Side-by-side comparison photo of two handle types"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-handles-contour-wire2@1x.jpg"
              src2="contrology-handles-contour-wire2@2x.jpg"
              alt="Leather handle photo"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-handles-contour-wire3@1x.jpg"
              src2="contrology-handles-contour-wire3@2x.jpg"
              alt="Wire handles photo"
            />
          </photo-grid>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology Handles</h2>
              <h3>Wire Contoured Handles</h3>
              <p>
                Fashioned after the handles used in Joseph Pilates’ studio, our Contrology Wire Contoured Handles have an ergonomically contoured wood grip inside a "wire basket". It is thought this handle may have been a popular design in the mid 1900s. This handle may be used on all Contrology apparatus.
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >90-Day Limited Warranty</icon-link>
            </section>

          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";

export default {
  name: "handles",

  metaInfo: {
    title: "Pilates Handles - Contrology Handles - Wire Contoured Handles",
    titleTemplate: "%s",
    meta: [
        {
          name: "description",
          content: "Fashioned after Pilates Handles used in Joseph Pilates' studio, these Wire Contoured Pilates Handles will take you a step back in time. Shop for Pilates Handles now."
        }
      ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      product: {
        label: "Select a Handle",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41267963363521,
          partnumber: 17174,
          price: 45,
          name: "Wire Contoured Handles",
          available: true
        },
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.handle-title {
  font-weight: 700;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
